import React from 'react';
import { ReactSVG } from 'react-svg';
import { ChevronRight } from '@mui/icons-material';
import SelectableListItemStyles from './SelectableListItem.module.css';
import ListItemStyles from './list-item.module.css';

const styles = { ...ListItemStyles, ...SelectableListItemStyles };

const SelectableListItem = ({ icon, label, onClick, id, style }) => {
  return (
    <button
      key={id}
      onClick={onClick}
      style={{ ...style }}
      className={`${styles.listItem} ${styles.selectableItem} ${styles.listItemPadding} ${styles.listItemBorder}`}
    >
      <div className={styles.leftContent}>
        <ReactSVG src={icon} className={styles.icon} />
        <span className={styles.label}>{label}</span>
      </div>
      <ChevronRight className={styles.chevron} />
    </button>
  );
};

export default SelectableListItem;
